/**
 * Arranque del video al llegar a un punto (regla de negocio 1: salta solo).
 *
 * Los navegadores solo dejan reproducir por codigo, sin un toque justo antes,
 * un video silenciado. Con audio hace falta un gesto del usuario (politica de
 * autoplay documentada por MDN), y en Safari de iOS ese gesto tiene que ser
 * sobre el propio elemento: tocar "empezar" al principio del recorrido no sirve
 * para un video que se crea despues, al llegar al punto, sin que nadie toque.
 *
 * Por eso se prueba primero con sonido (Chrome y Firefox lo permiten cuando la
 * persona ya ha tocado la pagina) y, si el navegador lo rechaza, se arranca en
 * silencio para que el video salte igual. Quitar el silencio despues si esta
 * permitido, porque ya es un toque de la persona.
 *
 * Esta en una funcion aparte, sin React, para poder probarla sin navegador.
 */

export type ResultadoReproduccion = 'con_sonido' | 'silenciado' | 'bloqueado';

/** Lo unico que se usa del elemento de video, para poder probarlo con un doble. */
export interface ElementoReproducible {
  muted: boolean;
  play(): Promise<void>;
}

export async function reproducirConRespaldo(
  elemento: ElementoReproducible,
): Promise<ResultadoReproduccion> {
  try {
    await elemento.play();
    return elemento.muted ? 'silenciado' : 'con_sonido';
  } catch {
    // Rechazo esperado: NotAllowedError por la politica de autoplay. Se sigue
    // al intento en silencio, que es justo el caso que esta funcion resuelve.
  }

  // Si ya estaba en silencio y aun asi se rechazo, callarlo mas no cambia nada.
  if (elemento.muted) return 'bloqueado';

  elemento.muted = true;
  try {
    await elemento.play();
    return 'silenciado';
  } catch {
    // Tambien en silencio: pasa en iOS en modo de ahorro de energia, o si el
    // fichero no carga. Se deja el elemento como estaba y la ficha ofrece el
    // boton de reproducir, que funciona porque ese si es un toque.
    elemento.muted = false;
    return 'bloqueado';
  }
}
